module.exports = __webpack_public_path__ + "img/3_0.0cdd9029.png";